export const companyNameSelector = customer => customer?.companyName;
export const customerIdSelector = customer => customer?.id;
export const subscriptionStatusSelector = customer => customer?.subscriptionStatus;
